/** Include field validation from the API instead of hiding it behind a generic failure. */
export function localSEOError(error: unknown, fallback: string): string {
  const data = (error as {response?: {data?: Record<string, unknown>}})?.response?.data;
  if (!data) return fallback;
  return Object.entries(data).map(([field, value]) => {
    const message = Array.isArray(value) ? value.join(' ') : typeof value === 'string' ? value : '';
    return message ? `${['detail', 'error', 'non_field_errors'].includes(field) ? '' : field.replaceAll('_', ' ') + ': '}${message}` : '';
  }).filter(Boolean).join(' ') || fallback;
}
